// This is not compatible with tsconfig target es5
//
// export default class Counter extends Map {
//   key: any;
//   constructor(iter, key = null) {
//     super();
//     this.key = key || (x => x);
//     for (const x of iter) {
//       this.add(x);
//     }
//   }
//   add(x) {
//     x = this.key(x);
//     this.set(x, (this.get(x) || 0) + 1);
//   }
// }

// https://stackoverflow.com/questions/17313268/idiomatically-find-the-number-of-occurrences-a-given-value-has-in-an-array/17313444

/**
 * Count elements on an object or array and returns an object with pair key,value where key is the element to find,
 * and value the amount of times it appears
 * @param ary The element to iterate on
 * @param classifier The classifier to use, if not provided, treats the object as a regular array
 * @example
 * people = [
 *     {name: 'Lisa', gender: 'girl'},
 *     {name: 'Bill', gender: 'boy'},
 *     {name: 'Maklatura', gender: 'girl'}
 *   ];
 *   * If you don't provide a `classifier` this simply counts different elements:
 *   cc = count([1, 2, 2, 2, 3, 1]);
 *   * With a `classifier` you can group elements by specific property:
 *   countByGender = count(people, item => item.gender);
 *
 */
export const countElements = function(ary: any, classifier: any = String) {
  return ary.reduce(function(counter, item) {
    const p = classifier(item);
    counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1;
    return counter;
  }, {});
};
